// extracted by mini-css-extract-plugin
export default {"mainContainer":"Sidebar_mainContainer__c8V0X","linksContainer":"Sidebar_linksContainer__g4NVG","link":"Sidebar_link__KD3Jc","active":"Sidebar_active__YK5Si"};